import React, { useState, useEffect } from "react";
import VotingUI from "../components/VotingUI";
import "../styles/proposalDetails.css";
import { useParams } from "react-router-dom";
import CommunityDetailsSideBar from "../components/CommunityDetailsSideBar";
import { db } from "../utils/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";

export default function Proposal() {
  const { id } = useParams();

  const [voter, setVoter] = useState({});
  const [proposal, setProposal] = useState({});
  const [propInfo, setPropInfo] = useState({});
  const [time, setTime] = useState("");

  useEffect(() => {
    async function getUser() {
      if (localStorage.getItem("id") == null) return;
      const docRef = doc(db, "Users", localStorage.getItem("id"));
      const result = await getDoc(docRef);
      setVoter(result.data());
    }

    getUser();

    async function getProposal() {
      const docRef = doc(db, "Proposals", id);
      setPropInfo(docRef);
      const snap = await getDoc(docRef);
      setProposal(snap.data());
      console.log(new Date());
      console.log(snap.data().endDate.toDate());
      setTime(snap.data().endDate.toDate().toDateString());
    }
    getProposal();
  }, []);

  const approve = async () => {
    await updateDoc(propInfo, {
      status: "active",
    });
    document.getElementById("status").innerHTML = "Status: Active";
    document.getElementById("statusButton").style.display = "none";
  };

  const disable = async () => {
    await updateDoc(propInfo, {
      status: "pending",
    });
    document.getElementById("status").innerHTML = "Status: Pending";
    document.getElementById("statusButton").style.display = "none";
  };
  // console.log(proposal);

  return (
    <>
      <div className="container mt-5">
        <div className="row">
          {/* Left Col - NFT/DAO Info  */}
          <div className="col-lg-4">
            <div className="card">
              <CommunityDetailsSideBar />
            </div>

            <br />
            <div className="card mb-4">
              <div className="card-body">
                <VotingUI proposal={proposal} voter={voter} />
              </div>
            </div>
          </div>

          {/* Right Col */}
          <div className="col-lg-8">
            <div className="proposalDetailsContainer">
              <div className="proposalDetailsHeader">
                <h1>{proposal.title} </h1>
                <div className="proposalDetailsItem">
                  <span>Voting time:</span> {time}
                </div>
                <div className="proposalDetailsItem">
                  <span>Budget:</span> {proposal.budget}
                </div>
              </div>

              <div className="flex" style={{ display: "flex" }}>
                <div className="proposalDetailsItem" id="status">
                  <span>Status:</span> {proposal.status}
                </div>
                &ensp;
                {/* <h3>
                  {proposal.status == "pending" && voter.userTypeNumber == 4 ? (
                    <button id="statusButton" onClick={approve}>
                      Approve
                    </button>
                  ) : null}
                  {proposal.status == "active" && voter.userTypeNumber == 4 ? (
                    <button id="statusButton" onClick={disable}>
                      Disable
                    </button>
                  ) : null}
                </h3> */}
              </div>

              {proposal.image && (
                <img src={proposal.image} alt="" className="img-fluid" />
              )}

              <p
                className="text-muted"
                dangerouslySetInnerHTML={{ __html: proposal.description }}
              ></p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
